/**
 * Created by pmnia on 8/4/15.
 */
(function (app) {
    'use strict';
    app.run(enableLanguageSwitching);

    /*@ngInject*/
    function enableLanguageSwitching($rootScope, $translate){
        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                if (toParams.language !== $translate.use()) {
                    $translate.use(toParams.language);  //switch language
                }
            }
        );
    }

})(angular.module('app.data'));



/*****************
 ** WEBPACK FOOTER
 ** ./app/language/language.run.js
 ** module id = 214
 ** module chunks = 0
 **/